const messages = {
  en: {
    unavailable: 'The assistant is temporarily unavailable. Please try again later.',
    unpublished: 'This assistant is not published yet. Please try again later.',
    connection: 'The conversation was interrupted. Check your connection, then close this chat and start a new conversation.',
    configuration: 'This assistant is not available on this page. Please contact the website owner.',
    expired: 'Your session has expired. Please start a new conversation.',
    busy: 'The assistant is busy. Please wait a moment and try again.',
    microphone: 'Microphone access is unavailable. Check your browser permissions.',
    upload: 'The file could not be uploaded. Please try again.',
    fileSize: 'This file is too large.',
    fileType: 'This file type is not supported.',
  },
  pt: {
    unavailable: 'O assistente está temporariamente indisponível. Tente novamente mais tarde.',
    unpublished: 'Este assistente ainda não está publicado. Tente novamente mais tarde.',
    connection: 'A conversa foi interrompida. Verifique sua conexão, feche este chat e inicie uma nova conversa.',
    configuration: 'Este assistente não está disponível nesta página. Entre em contato com o responsável pelo site.',
    expired: 'Sua sessão expirou. Inicie uma nova conversa.',
    busy: 'O assistente está ocupado. Aguarde um momento e tente novamente.',
    microphone: 'O acesso ao microfone está indisponível. Verifique as permissões do navegador.',
    upload: 'Não foi possível enviar o arquivo. Tente novamente.',
    fileSize: 'Este arquivo é muito grande.',
    fileType: 'Este tipo de arquivo não é compatível.',
  },
  es: {
    unavailable: 'El asistente no está disponible temporalmente. Inténtalo más tarde.',
    unpublished: 'Este asistente aún no está publicado. Inténtalo más tarde.',
    connection: 'La conversación se interrumpió. Revisa tu conexión, cierra este chat e inicia una nueva conversación.',
    configuration: 'Este asistente no está disponible en esta página. Contacta al responsable del sitio.',
    expired: 'Tu sesión ha caducado. Inicia una nueva conversación.',
    busy: 'El asistente está ocupado. Espera un momento e inténtalo de nuevo.',
    microphone: 'El acceso al micrófono no está disponible. Revisa los permisos del navegador.',
    upload: 'No se pudo subir el archivo. Inténtalo de nuevo.',
    fileSize: 'Este archivo es demasiado grande.',
    fileType: 'Este tipo de archivo no es compatible.',
  },
};

type ErrorKind = keyof typeof messages.en;

export function widgetErrorMessage(error: unknown, language = 'en', fallback: ErrorKind = 'unavailable'): string {
  const detail = error as any;
  const code = String(detail?.code || detail?.body?.error || detail?.error || '').toLowerCase();
  const description = `${code} ${typeof error === 'string' ? error : detail?.message || ''}`.toLowerCase();
  let kind = fallback;
  if (/not[_ ]published/.test(description)) kind = 'unpublished';
  else if (/invalid_secret|missing_credentials|origin_not_allowed|origin_mismatch|no_modality_enabled/.test(description)) kind = 'configuration';
  else if (/expired|invalid_token|missing_token|session_not_found/.test(description) || detail?.status === 401) kind = 'expired';
  else if (/rate_limit|too_many|quota_exceeded/.test(description) || detail?.status === 429) kind = 'busy';
  else if (/microphone|notallowederror|notfounderror|notreadableerror/.test(`${description} ${String(detail?.name).toLowerCase()}`)) kind = 'microphone';
  else if (/file.too.large|file_size/.test(description)) kind = 'fileSize';
  else if (/file.type|mime.type/.test(description)) kind = 'fileType';
  else if (/runtime_unreachable|failed to fetch|network|timeout|timed out|connection|abort/.test(description) || [502, 503, 504].includes(detail?.status) || ['AbortError', 'TimeoutError'].includes(detail?.name)) kind = 'connection';
  const locale = language.toLowerCase().split(/[-_]/)[0] as keyof typeof messages;
  return (messages[locale] || messages.en)[kind];
}